import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const WorkgroupMappingList = {
  columns: [
    {
      name: "Group Name",
      fieldName: "groupName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Type",
      fieldName: "groupTypeName",
      allowShort: false,
    },
    {
      name: "EXCO Member",
      fieldName: "excoMember",
      colType: GridColumnType.Text,
      allowShort: false,
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      customWrapper: [
        {
          name: "SELECTINDIVIDUALRECORD",
          label: "Select Individual Record",
        },
        {
          name: "ADDINDIVIDUALRECORD",
          label: "Add Individual Record",
        },
        {
          name: "EDIT",
          label: "Edit",
        },
      ],
      defaultAction: {
        allowEdit: false,
        allowDelete: true,
      },
      allowShort: false,
    },
  ],
  allowEdit: false,
  isRowSelectable: true,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};

